import { useEffect } from 'react';

export default function useEscapeKey(onClose) {
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        // Don't close the modal if a date picker popover is open
        const datePickerPopover = document.querySelector('.react-datepicker-popper');
        if (datePickerPopover) return;
        onClose();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [onClose]);
}
